import "../../../styles/kjedeweb/singleChainProductListItem.scss";

import Icon, { iconTypes } from "../../common/components/Icon.jsx";

import { Localization } from "../../common/util/localization.jsx";
import MultiChainProductModal from "./MultiChainProductModal";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../common/components/ResponsiveRows";
import { getChainLogo } from "./MultiChainSortimentListItem";
import moment from "moment";

export class MultiEpixSortimentListHeader extends React.PureComponent {
    render() {
        const {
            localization,
            showInvoiceGroup,
        } = this.props;

        return (
            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                <ResponsiveRows gutters={false}>
                    <ResponsiveColumn  lg={2.5}>
                        <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                            {localization.text("chain", "chainSortiment", "productAndStatus")}
                        </div>
                    </ResponsiveColumn>                                   
                    <ResponsiveColumn lg={1}>
                        <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                            {localization.text("chain", "chainSortiment", "productStatus")}
                        </div>
                    </ResponsiveColumn>
                    <ResponsiveColumn  lg={1}>
                        <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                            {localization.text("chain", "chainSortiment", "noOfSalesUnits")}
                        </div>
                    </ResponsiveColumn>
                    <ResponsiveColumn  lg={1}>
                        <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                            {localization.text("chain", "chainSortiment", "changed")}
                        </div>
                    </ResponsiveColumn>     
                    {showInvoiceGroup && (
                        <ResponsiveColumn  lg={1}>
                            <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                {localization.text("chain", "chainSortiment", "invoiceGroup")}
                            </div>
                        </ResponsiveColumn>
                    )}
                    <ResponsiveColumn  lg={3.5}>
                        <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                            {localization.text("chain", "chainSortiment", "chainStatus")}
                        </div>
                    </ResponsiveColumn>
                    <ResponsiveColumn lg={1}>
                        <div style={{ textIndent: "0px" }}>
                        </div>
                    </ResponsiveColumn>
                </ResponsiveRows>
            </div>
        );
    }
}

MultiEpixSortimentListHeader.propTypes = {
    localization: Localization.propTypes.isRequired,
    showInvoiceGroup : PropTypes.bool,
};

export class MultiEpixSortimentListItem extends React.PureComponent {
    constructor(props) {
        super(props);

        //this.onDeleteProduct = this.onDeleteProduct.bind(this);
        this.showProductModal = this.showProductModal.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
    }

    showProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        const {
            localization,
            productGroup,
        } = this.props;

        if (productGroup.find(pg => pg.inCatalogue)) {
            this.props.setModal(<MultiChainProductModal localization={localization} product={productGroup[0]} onCloseModal={this.closeProductModal} width={1400} title={localization.text("chain", "productDetail")} saveButtonText={localization.text("chain", "save")} />);
        } else {
            this.props.setModal(<MultiChainProductModal localization={localization} product={productGroup[0]} onCloseModal={this.closeProductModal} width={1400} title={localization.text("chain", "addProductToChain")} saveButtonText={localization.text("chain", "saveAndAddProduct")} />);
        }
    }
    closeProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.setModal(null);
        this.props.clearEpixProductDetails();
    }

    capitalizeFirstLetter(s) {
        s = s.toLowerCase();
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    // onDeleteProduct() {
    //     let {
    //         productGroup,
    //     } = this.props;

    //     productGroup = productGroup.map(product => ({
    //         ...product,
    //         inCatalogue: false
    //     }));
    //     this.props.updateChainProducts(productGroup);
    // }

    render() {
        const {
            chains,
            localization,
            productGroup,
        } = this.props;

        let statusColumns;

        if (productGroup.find(pg => pg.inCatalogue)) {
            statusColumns = [
                <ResponsiveColumn key="8" lg={3.5} className="multi-epix-sortiment-chain-status">
                    {productGroup.map(product => (
                        <div key={product.chainId} className="multi-epix-sortiment-chain-status-chain">
                            <div>
                                <img className={"product-view-list-item-logo"} src={getChainLogo(chains && chains[product.chainId] && chains[product.chainId].chainLogoFileName)}/>
                            </div>
                            <div className="status-dots">
                                <div className="product-view-list-item-prd-info_catalogueInfo" >
                                    <div className={product.inCatalogue ?"circle-green" : "circle-red"}/>
                                </div>
                                {/* <div className="product-view-list-item-prd-info_catalogueInfo" >
                                    <div className={product.inCatalogue ? "circle-blue" : "circle-gray"}/>
                                </div>*/}
                            </div>
                        </div>  
                    ))}
                </ResponsiveColumn>,
                <ResponsiveColumn key="12" lg={1}>
                    <div className="product-view-list-icon">
                        {/* <button className="btn circular" onClick={this.onDeleteProduct}>
                            <Icon type={iconTypes.x} color={iconColor.red} />
                        </button> */}
                        <div style={{ paddingLeft: "10px" }}>
                            <button className="btn circular" onClick={this.showProductModal}>
                                <Icon type={iconTypes.pen} />
                            </button>
                        </div>
                    </div>
                </ResponsiveColumn>];
        } else {
            statusColumns = [
                <ResponsiveColumn key="11" lg={3.5}>
                    <div className="label14 product-view-list-item">
                        <div style={{ width: "100%" }}>
                            {localization.text("chain", "epixSortiment", "addPrices")}
                        </div>
                    </div>
                </ResponsiveColumn>,
                <ResponsiveColumn key="12" lg={1}>
                    {/* <div className="product-view-list-icon">
                        <div style={{ paddingLeft: "10px" }}>
                            <button className="btn" style={{ width: "170px" }} onClick={this.showProductModal}>
                                <Icon type={iconTypes.plus} color={iconColor.red} />
                                {localization.text("chain", "addProduct")}
                            </button>
                        </div>
                    </div> */}
                </ResponsiveColumn>];
        }

        const product = productGroup[0];

        return (
            <div className="product-view-list-item-wrapper not-interactable" draggable={false}>
                <div className="container">
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn lg={2.5}>
                            <div className={"product-view-list-item"}>
                                <div className={"product-view-list-item-image-background"} onClick={this.showProductModal}>
                                    {product.imageUrl && (
                                        <React.Fragment>
                                            <img src={product.imageUrl} className={"product-view-list-item-image"} />
                                        </React.Fragment>
                                    )}
                                </div>
                                <div className="label16 product-view-list-item-prd-info_multiline" onClick={this.showProductModal}>
                                    <div>EPD {product.epdNo}</div>
                                    <div>{product.productName}</div>
                                </div>
                            </div>
                        </ResponsiveColumn>                                              
                        <ResponsiveColumn lg={1}>
                            <div className="label14 product-view-list-item">
                                <div style={{ width: "100%" }}>
                                    {product.status}
                                </div>
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn lg={1}>
                            <div className="label14 product-view-list-item-price">
                                <div style={{ width: "100%" }}>
                                    {product.noOfSalesUnits}
                                </div>
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn lg={1}>
                            <div className="label14 product-view-list-item">
                                <div style={{ width: "100%" }}>
                                    {product.lastChangedDate && moment(product.lastChangedDate).format("DD.MM.YY")}
                                </div>
                            </div>
                        </ResponsiveColumn> 
                        {product.showInvoiceGroup && (
                            <ResponsiveColumn lg={1}>
                                <div className="label14 product-view-list-item">
                                    <div style={{ width: "100%" }}>
                                        {this.capitalizeFirstLetter(product.invoiceGroupName)}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                        )}
                        {statusColumns}
                    </ResponsiveRows>
                </div>
            </div >
        );
    }
}

MultiEpixSortimentListItem.propTypes = {
    chains: PropTypes.object.isRequired,
    clearEpixProductDetails: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    saveButtonText: PropTypes.string,
    setModal: PropTypes.func.isRequired,
    productGroup: PropTypes.array,
    updateChainProducts: PropTypes.func.isRequired,
};

MultiEpixSortimentListItem.defaultProps = {
};